/**
 * 软胶囊皮肤的卡片外壳与零件：大圆角托盘、托盘上的白色纸面、胶囊、小圆点。
 * 表单类卡片（采集卡、预览卡、邮件结果卡、入口卡、状态卡）和数据类卡片（尺码、对比、订单、验证码）共用。
 * 颜色和圆角从组件根节点上的 --gn-form-* 变量读，所以要和 FORM_STYLES 一起放进同一个 Shadow DOM，
 * 变量由 formVars(tokens) 给。
 *
 * 每张卡只有一个「墨黑答案」：推荐尺码、对比里更好的一项、订单当前站、验证码当前格都是同一块实心墨黑
 * （data-current）；还没到的用虚线（data-future）；商家主色只出现在小圆点上（.gn-dot）。
 */
export const CARD_STYLES = `
.gn-card { box-sizing:border-box; width:100%; max-width:360px; display:flex; flex-direction:column; gap:10px; padding:12px; border:0; border-radius:var(--gn-form-r-card); background:var(--gn-form-tray); color:var(--gn-form-ink); font-size:13px; line-height:1.45; text-align:left; }
.gn-card-head { display:flex; justify-content:space-between; align-items:flex-start; gap:8px; padding:2px 4px 0; }
.gn-card-title { margin:0; font-size:15px; font-weight:700; letter-spacing:-.01em; line-height:1.25; }
.gn-card-body { display:flex; flex-direction:column; gap:8px; padding:0; }
.gn-card-foot { display:flex; flex-direction:column; gap:8px; padding:0; }
.gn-caption { font-size:12px; font-weight:var(--gn-form-strong); color:var(--gn-form-quiet); letter-spacing:0; }
.gn-well { box-sizing:border-box; display:flex; flex-direction:column; gap:10px; padding:8px; border-radius:var(--gn-form-r-well); background:var(--gn-form-sheet); }
.gn-well[data-roomy] { padding:10px; }
.gn-chip { box-sizing:border-box; display:inline-flex; align-items:center; justify-content:center; gap:6px; min-height:32px; padding:0 12px; border:0; border-radius:var(--gn-form-r-pill); background:var(--gn-form-chip); color:var(--gn-form-ink); font:inherit; font-size:12px; font-weight:700; white-space:nowrap; }
.gn-chip[data-current] { background:var(--gn-form-answer); color:var(--gn-form-answer-fg); font-weight:800; }
.gn-chip[data-future] { background:transparent; border:1.5px dashed var(--gn-form-dash); color:var(--gn-form-quiet); }
.gn-dot { flex:none; box-sizing:border-box; width:6px; height:6px; border-radius:999px; background:var(--gn-form-dot); }
.gn-dot[data-size="8"] { width:8px; height:8px; }
.gn-dot[data-current] { background:currentColor; }
.gn-dot[data-future] { background:transparent; border:1.5px dashed var(--gn-form-dash); }
`;
